import React, { useEffect, useState } from 'react';
import PageTitle from '../components/pagetitle/PageTitle';
import About1 from '../components/about/About1';
import Partner from '../components/partner/Partner';
import Footer from '../components/footer';
import dataPartner from '../assets/fake-data/data-partner';
import Team2 from '../components/team/Team2';
import dataTeam from '../assets/fake-data/data-team';
import DataAbout from '../assets/fake-data/data-about';
import { useTranslation } from 'react-i18next';
import Loader from '../components/loader/loader';

function About01() {
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const handleLoad = () => {
            setIsLoading(false);
        };

        if (document.readyState === "complete") {
            setIsLoading(false);
        } else {
            window.addEventListener("load", handleLoad);    
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []);
    return (
        <>
        {isLoading ? (
            <div style={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              height: "80vh",
              
            }}>
              <Loader />
            </div>
          ) : (
        <div className='page-about home-1'>
            <PageTitle title={t('About Us')} />

            <About1 data={DataAbout} />

            {/* <Team2 data={dataTeam} />

            <Partner data={dataPartner} /> */}

            <Footer />
            
        </div>
        )}
        </>
    );
}

export default About01;